import theme from '../themes/default';

export default {
	wrap: {},
	'list-wrap': {
		color: '#000',
		'& .am-list-content': {
			'& .list-item': {
				'&:after': {
					content: '"、"'
				},
				'&:last-child': {
					'&:after': {
						content: '" "'
					}
				}
			}
		},
		'& .am-list-item': {
			'min-height': '55px'
		},
		'& .am-radio-inner': {
			'&:after': {
				'border-color': '#614D4A !important'
			}
		},
		'& .am-radio-wrapper': {
			'& .am-radio': {
				height: '100% !important',
				'& .am-radio-inner': {
					top: '40% !important'
				}
			}
		}
  },
  'dinein-credit-card-tel-input': {
    'border-top-left-radius': '5px',
    'border-top-right-radius': '5px',
    'border-bottom-left-radius': '5px',
    'border-bottom-right-radius': '5px',
    'margin-top': '15px',
    'margin-bottom': '5px',
    padding: '10px',
    width: 'calc(100% - 20px)',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
  },
  'dinein-credit-card-tel-input::placeholder': {
    color: '#A2A2A2',
  },
	'dinein-credit-card-select': {
		background: '#fff',
		color: '#A2A2A2',
		'border-top-left-radius': '5px',
		'border-top-right-radius': '5px',
		'border-bottom-left-radius': '5px',
		'border-bottom-right-radius': '5px',
		'margin-top': '15px',
		'margin-bottom': '5px',
		padding: '10px',
		width: 'calc(100% - 20px)',
		border: '1px',
		borderStyle: 'solid',
		borderColor: '#D8D8D8'
	},
	'dinein-credit-card-footer': {
		// position: 'absolute',
		// bottom: '50px',
		// width: '100%',
		background: '#4A8CA1',
		height: '70px',
		color: '#fff',
		'text-align': 'center',
		'font-size': '16px',
		'line-height': '70px',
		'vertical-align': 'middle',
		'z-index': '9',
		position: 'relative',
    bottom: '-16px',
    margin: '0 20px'
	},
	'dinein-credit-card-footer-invalid': {
		// position: 'absolute',
		// bottom: '50px',
		// width: '100%',
		height: '70px',
		color: '#fff',
		'text-align': 'center',
		'font-size': '16px',
		'line-height': '70px',
		'vertical-align': 'middle',
		'z-index': '9',
		background: '#D8D8D8',
		position: 'relative',
    bottom: '-16px',
    margin: '0 20px'
  },
  'dinein-credit-card-title': {
    'font-size': '20px',
    'margin-top':'15px'
  }
};



// WEBPACK FOOTER //
// ./src/assets/styles/components/Dialog.js